import { useLoaderData } from "react-router-dom";
import { routeApis } from "../../../constants/apis";
import { Routes } from "../../../constants/routes";
import { updatePortalUser } from "../../../loaders/pages/portalUserDetail";
import { UserManagementDetailPageTemplate } from "../../templates/userManagementDetailPageTemplate";
import { columnConfig } from "../../../constants/columnConfig";

/**
 * Portal User Detail page component.
 * Displays detailed information about a specific portal user, including:
 * - User profile information
 * - Client portal page access restrictions (for active client portal users)
 * - Email change request history
 * - User reactivation options (for eligible users)
 *
 * @returns {JSX.Element} The rendered portal user detail page
 */
export const PortalUserDetail = (): JSX.Element => {
  // Load user data from the route loader
  let { azureUserId, data: user, error }: any = useLoaderData();

  // Get configuration for hidden fields and field display order
  const { hiddenFields: hidden, order } = columnConfig.portalUserDetail;

  return (
    <UserManagementDetailPageTemplate
      azureUserId={azureUserId}
      user={user}
      pageTitleText={`Portal User - ${user.displayName}`}
      saveText="Save changes"
      viewText="Edit"
      userFieldsOrder={order}
      hiddenUserFields={hidden}
      apis={{
        get: routeApis[Routes.PORTAL_USERS].portalUsers,
      }}
      updateApi={updatePortalUser}
      error={error}
    />
  );
};
